module.exports = {
	"id": "MN",
	"name": "Mongolia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.012918,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006459,
			"11": 0.025836,
			"12": 0.025836,
			"13": 0.025836,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.032295,
			"19": 0.025836,
			"20": 0.006459,
			"21": 0.006459,
			"22": 0.038754,
			"23": 0.103344,
			"24": 0.012918,
			"25": 0.06459,
			"26": 0.019377,
			"27": 0.045213,
			"28": 0.032295,
			"29": 0.012918,
			"30": 0.071049,
			"31": 0.025836,
			"32": 0.038754,
			"33": 0.045213,
			"34": 0.025836,
			"35": 0.019377,
			"36": 0.032295,
			"37": 0.006459,
			"38": 0.032295,
			"39": 0.032295,
			"40": 0.025836,
			"41": 0.012918,
			"42": 0.032295,
			"43": 0.238983,
			"44": 0.083967,
			"45": 0.155016,
			"46": 0.096885,
			"47": 0.161475,
			"48": 0.071049,
			"49": 1.324095,
			"50": 0.200229,
			"51": 1.272423,
			"52": 0.665277,
			"53": 31.19697,
			"54": 8.409618,
			"55": 0.284196,
			"56": 0.083967,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006459,
			"4": 0.045213,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.019377,
			"10": 0.006459,
			"11": 0.019377,
			"12": 0.032295,
			"13": null,
			"14": 0.012918,
			"15": 0.019377,
			"16": 0.025836,
			"17": 0.012918,
			"18": 0.025836,
			"19": 0.006459,
			"20": 0.012918,
			"21": 0.006459,
			"22": null,
			"23": 0.006459,
			"24": 0.019377,
			"25": null,
			"26": 0.012918,
			"27": 0.012918,
			"28": 0.012918,
			"29": 0.032295,
			"30": 0.045213,
			"31": 0.012918,
			"32": 0.025836,
			"33": 0.012918,
			"34": 0.012918,
			"35": 0.012918,
			"36": 0.012918,
			"37": 0.045213,
			"38": 0.103344,
			"39": 0.025836,
			"40": 0.06459,
			"41": 0.045213,
			"42": 0.045213,
			"43": 0.284196,
			"44": 0.148557,
			"45": 0.200229,
			"46": 0.135639,
			"47": 0.846129,
			"48": 0.691113,
			"49": 8.338569,
			"50": 0.607146,
			"51": 0.012918,
			"52": null,
			"3.5": 0.051672,
			"3.6": 0.025836
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.019377,
			"36": 0.025836,
			"37": null,
			"38": 0.032295,
			"39": 0.012918,
			"40": 1.201374,
			"41": 0.12918,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.006459
		},
		"safari": {
			"0": null,
			"4": 0.006459,
			"5": null,
			"6": null,
			"7": 0.038754,
			"8": 0.051672,
			"9": 0.109803,
			"10": 0.465048,
			"3.1": null,
			"3.2": null,
			"5.1": 0.025836,
			"6.1": 0.025836,
			"7.1": null,
			"9.1": 0.432753
		},
		"ios_saf": {
			"8": 0,
			"10": 4.9937328418,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.134575321711,
			"8.1-8.4": 0.248622204517,
			"9.0-9.2": 0.118608758118,
			"9.3": 1.80954387386
		},
		"android": {
			"3": 0,
			"4": 0.237109751938,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0296387189922,
			"4.1": 0.855288748062,
			"4.2-4.3": 2.13822187016,
			"4.4": 4.90309094186,
			"4.4.3-4.4.4": 4.94543196899
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.402303428571,
			"9": 0.0416175960591,
			"10": 0.0693626600985,
			"11": 0.894778315271,
			"5.5": null
		},
		"op_mob": {
			"0": 0.029059410486,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000807205846833
		},
		"edge": {
			"12": 0.071049,
			"13": 0.167934,
			"14": 0.329409
		},
		"ie_mob": {
			"10": 0.0174556338028,
			"11": 0.0710693661972
		},
		"bb": {
			"7": 0.01681975,
			"10": null
		},
		"samsung": {
			"0": 3.601197
		},
		"and_uc": {
			"0": 0.3541
		},
		"op_mini": {
			"0": 0.391512383667
		},
		"and_chr": {
			"0": 11.580077
		},
		"and_ff": {
			"0": 0.046033
		}
	},
	"total": 98.37983875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MN.json
 ** module id = 591
 ** module chunks = 0
 **/